"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __spreadArray = this && this.__spreadArray || function (to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
    to[j] = from[i];
  }
  return to;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var reconnect_js_1 = require("reconnect.js");
var StorageActions = __importStar(require("../../Actions/Storage"));
var ArrowToRight_1 = require("@styled-icons/boxicons-regular/ArrowToRight");
var ArrowToLeft_1 = require("@styled-icons/boxicons-regular/ArrowToLeft");
var Trash_1 = require("@styled-icons/boxicons-regular/Trash");
var styled_components_1 = __importDefault(require("styled-components"));
var antd_1 = require("antd");
function ImageUpload(props) {
  var _this = this;
  var actions = reconnect_js_1.useOutlet('actions')[0];
  var onFinished = props.onFinished,
    images = props.images,
    maxLength = props.maxLength,
    token = props.token;
  var _a = react_1.useState(false),
    dragging = _a[0],
    setDragging = _a[1];
  var onFileSelect = function onFileSelect(e) {
    return __awaiter(_this, void 0, void 0, function () {
      var file, resp, formData, payload, key, e_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            _a.trys.push([0, 4, 5, 6]);
            if (maxLength) {
              if (images.length + 1 > maxLength) {
                antd_1.message.error('超過上傳限制');
                return [2 /*return*/];
              }
            }

            actions.setLoading(true);
            file = e.target.files[0];
            if (!file) return [3 /*break*/, 3];
            return [4 /*yield*/, StorageActions.getUploadUrlFromFile(file, {
              token: token
            })];
          case 1:
            resp = _a.sent();
            formData = new FormData();
            payload = __assign(__assign({}, resp.fields), {
              file: file
            });
            for (key in payload) {
              formData.append(key, payload[key]);
            }
            return [4 /*yield*/, StorageActions.uploadFile(resp.url, formData)];
          case 2:
            _a.sent();
            if (onFinished) {
              onFinished(resp.expected);
            }
            _a.label = 3;
          case 3:
            return [3 /*break*/, 6];
          case 4:
            e_1 = _a.sent();
            console.warn(e_1);
            return [3 /*break*/, 6];
          case 5:
            actions.setLoading(false);
            return [7 /*endfinally*/];
          case 6:
            return [2 /*return*/];
        }
      });
    });
  };

  var onFilesDrop = function onFilesDrop(e) {
    return __awaiter(_this, void 0, void 0, function () {
      var fileList, urlList, i, file, _i, fileList_1, file, resp, formData, payload, key, e_2;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            e.preventDefault();
            _a.label = 1;
          case 1:
            _a.trys.push([1, 7, 8, 9]);
            fileList = [];
            urlList = [];
            if (e.dataTransfer.items) {
              for (i = 0; i < e.dataTransfer.items.length; i++) {
                if (e.dataTransfer.items[i].kind === 'file') {
                  file = e.dataTransfer.items[i].getAsFile();
                  fileList.push(file);
                }
              }
            }
            if (maxLength) {
              if (images.length + fileList.length > maxLength) {
                antd_1.message.error('超過上傳限制');
                return [2 /*return*/];
              }
            }

            actions.setLoading(true);
            _i = 0, fileList_1 = fileList;
            _a.label = 2;
          case 2:
            if (!(_i < fileList_1.length)) return [3 /*break*/, 6];
            file = fileList_1[_i];
            return [4 /*yield*/, StorageActions.getUploadUrlFromFile(file, {
              token: token
            })];
          case 3:
            resp = _a.sent();
            formData = new FormData();
            payload = __assign(__assign({}, resp.fields), {
              file: file
            });
            for (key in payload) {
              formData.append(key, payload[key]);
            }
            return [4 /*yield*/, StorageActions.uploadFile(resp.url, formData)];
          case 4:
            _a.sent();
            urlList.push(resp.expected);
            _a.label = 5;
          case 5:
            _i++;
            return [3 /*break*/, 2];
          case 6:
            if (onFinished) {
              onFinished(urlList);
            }
            return [3 /*break*/, 9];
          case 7:
            e_2 = _a.sent();
            console.warn(e_2);
            return [3 /*break*/, 9];
          case 8:
            actions.setLoading(false);
            setDragging(false);
            return [7 /*endfinally*/];
          case 9:
            return [2 /*return*/];
        }
      });
    });
  };

  return react_1.default.createElement(StyledImageUploader, {
    dragging: dragging
  }, react_1.default.createElement("input", {
    id: "rev-multiple-image-uploader",
    type: "file",
    onChange: onFileSelect
  }), react_1.default.createElement("label", {
    onDragEnter: function onDragEnter(e) {
      e.preventDefault();
      setDragging(true);
    },
    onDragLeave: function onDragLeave() {
      setDragging(false);
    },
    onDragOver: function onDragOver(e) {
      e.preventDefault();
    },
    onDrop: onFilesDrop,
    htmlFor: "rev-multiple-image-uploader"
  }, "\u9078\u64C7\u6216\u62D6\u66F3\u5716\u7247\u81F3\u6B64"));
}
var StyledImageUploader = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  input {\n    display: none;\n    opacity: 0;\n  }\n  label {\n    display: inline-block;\n    font-size: 14px;\n    border: 1px dashed #ccc;\n    border-radius: 3px;\n    padding: 10px 15px;\n    transition: all 400ms ease;\n    cursor: pointer;\n    :hover {\n      color: #40a9ff;\n      border-color: #40a9ff;\n    }\n    ", "\n  }\n"], ["\n  input {\n    display: none;\n    opacity: 0;\n  }\n  label {\n    display: inline-block;\n    font-size: 14px;\n    border: 1px dashed #ccc;\n    border-radius: 3px;\n    padding: 10px 15px;\n    transition: all 400ms ease;\n    cursor: pointer;\n    :hover {\n      color: #40a9ff;\n      border-color: #40a9ff;\n    }\n    ", "\n  }\n"])), function (_a) {
  var dragging = _a.dragging;
  return dragging ? "\n   border: 3px dashed #000; \n   color: #40a9ff;\n   border-color: #40a9ff;\n    " : "";
});
function MultiImageUpload(props) {
  var token = props.token;
  var images = props.formData || [];
  var removable = props.schema.removable !== false;
  var setImages = function setImages(nextImages) {
    props.onChange(nextImages);
  };
  var onFinished = function onFinished(imgUrl) {
    var nextImages = Array.isArray(imgUrl) ? __spreadArray(__spreadArray([], images), imgUrl) : __spreadArray(__spreadArray([], images), [imgUrl]);
    setImages(nextImages);
  };
  function moveElement(arr, old_idx, new_idx) {
    arr = __spreadArray([], arr);
    arr.splice(new_idx, 0, arr.splice(old_idx, 1)[0]);
    setImages(arr);
  }
  function deleteElement(arr, idx) {
    arr = __spreadArray([], arr);
    arr.splice(idx, 1);
    setImages(arr);
  }
  return react_1.default.createElement("div", {
    style: {
      margin: '10px 0',
      maxWidth: 800
    }
  }, react_1.default.createElement("p", {
    style: {
      marginBottom: 10
    }
  }, "\u5546\u54C1\u5716\u7247"), react_1.default.createElement(ImageUpload, {
    images: images,
    onFinished: onFinished,
    maxLength: props.schema.maxLength,
    token: token
  }), react_1.default.createElement("div", {
    style: {
      width: '100%',
      overflowX: 'auto'
    }
  }, react_1.default.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'row',
      marginTop: 10
    }
  }, Array.isArray(images) && images.map(function (img, idx) {
    return react_1.default.createElement(antd_1.Card, {
      bodyStyle: {
        height: 'calc(100% - 57px)'
      },
      key: idx,
      actions: removable ? [react_1.default.createElement(ArrowToLeft_1.ArrowToLeft, {
        size: 32,
        color: "#6b6b6b",
        onClick: function onClick() {
          return moveElement(images, idx, idx - 1);
        }
      }), react_1.default.createElement(ArrowToRight_1.ArrowToRight, {
        size: 32,
        color: "#6b6b6b",
        onClick: function onClick() {
          return moveElement(images, idx, idx + 1);
        }
      }), react_1.default.createElement(Trash_1.Trash, {
        size: 32,
        color: "#d40e00",
        onClick: function onClick() {
          return deleteElement(images, idx);
        }
      })] : [react_1.default.createElement(ArrowToLeft_1.ArrowToLeft, {
        size: 32,
        color: "#6b6b6b",
        onClick: function onClick() {
          return moveElement(images, idx, idx - 1);
        }
      }), react_1.default.createElement(ArrowToRight_1.ArrowToRight, {
        size: 32,
        color: "#6b6b6b",
        onClick: function onClick() {
          return moveElement(images, idx, idx + 1);
        }
      })]
    }, react_1.default.createElement("h2", {
      style: {
        width: 30,
        height: 30,
        fontStyle: 'italic'
      }
    }, idx + 1 + "."), react_1.default.createElement(antd_1.Image, {
      src: img,
      style: {
        objectFit: 'contain',
        width: 200,
        backgroundColor: '#fff',
        padding: 10
      },
      alt: "product-img"
    }));
  }))));
}
exports.default = MultiImageUpload;
var templateObject_1;